import { EMPTY_REFUND_MODEL } from "presentation/model/Refund/RefundModel";
import { useState } from "react";
import { createContainer } from "react-tracked";

const {
    Provider: RefundProvider,
    useTracked: useRefundTracked
} = createContainer(() => useState(EMPTY_REFUND_MODEL), { concurrentMode: true });
export { RefundProvider, useRefundTracked };

